import { Component } from '@angular/core';
import System from 'framework/System';
import Check from 'framework/Check';
import { TabPanelDisplayMode } from 'app/components/enums/TabPanelDisplayMode';
import { FileSectionTypes } from 'app/models/enums/FileSectionTypes';
import Utils from '../../../shared/utils';
import { CustomerFileService } from '../../../services/customer-file.service';

@Component({
	selector: 'app-components-managecustomer-files',
	templateUrl: './Files.component.html'
})
export class FilesComponent implements IActivatable {
    FileSectionTypes = FileSectionTypes;
    public title = 'Files';
    public customer: CustomerObservable;
    public customerId: number;
    public tabPanelDisplayMode = TabPanelDisplayMode;
    public hasSeoStarterSubscription = false;

    constructor(private customerFileService: CustomerFileService) { }

    public activate(params: any): JQueryPromise<any> {
        Check.isNotEmpty(params.customer, 'Customer is required');
        this.customer = params.customer;
        this.customerId = params.customer.CustomerId();
        this.hasSeoStarterSubscription = !!this.customer.AllProducts
            && this.customer.AllProducts().includes(Boo.Objects.Enums.ProductEnum.StarterSeo);
        return System.emptyPromise();
    }

    public generateMonthlyPdfReport(): void {
        this.customerFileService.generateMonthlySeoStarterReport(this.customerId)
            .subscribe({
                next: () => {
                    toastr.success('Monthly SEO Starter report generation has been queued. It may take up to 15 minutes for the report to be generated and appear in the customer files section.');
                },
                error: (error) => {
                    toastr.error(error);
                }
            });
    }
}
